module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cards"
    }
  }, [(_vm.cardList.length) ? _vm._l((_vm.cardList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "quan",
      class: {
        used: (item.use_status == 'yes')
      }
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "img"
    }, [(item.type == 'discount') ? _c('div', {
      staticClass: "tip"
    }, [_vm._v("折扣券")]) : (item.type == 'money') ? _c('div', {
      staticClass: "tip tip1"
    }, [_vm._v("代金券")]) : (item.type == 'gift') ? _c('div', {
      staticClass: "tip tip2"
    }, [_vm._v("礼品券")]) : (item.type == 'coupon') ? _c('div', {
      staticClass: "tip tip3"
    }, [_vm._v("优惠券")]) : _c('div', {
      staticClass: "tip tip3"
    }, [_vm._v("门票券")]), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../../../statics/imgs/quan.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("有效期：" + _vm._s(item.end_time.split(' ')[0]))])])]), _vm._v(" "), (item.use_status == 'no') ? _c('div', {
      staticClass: "state"
    }, [_c('div', {
      staticClass: "cut"
    }), _vm._v(" "), (item.type == 'ticket') ? _c('a', {
      staticClass: "btn"
    }) : _c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.getCode(item)
        }
      }
    }, [_vm._v("兑换")])]) : _c('div', {
      staticClass: "state over"
    }, [_c('div', {
      staticClass: "cut"
    }), _vm._v("\n          已使用\n        ")])])
  }) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "codebox"
  }, [_c('p', [_vm._v("兑奖二维码")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.codeImg
    }
  }), _vm._v(" "), _c('p', [_vm._v("兑奖码：" + _vm._s(_vm.qrCode))])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a79464"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/cards.vue
// module id = 465
// module chunks = 0